import { CalendarDays, Heart, Home, ListChecks, MoreHorizontal, NotebookPen, type LucideIcon } from 'lucide-react';
import { CalendarPumpkinIcon, ClipboardBatIcon, GhostIcon, type SpookyIconComponent } from '../icons/SpookyIcons';

export type ViewId =
  | 'home'
  | 'calendar'
  | 'tasks'
  | 'notes'
  | 'more'
  | 'events'
  | 'shopping'
  | 'favorites'
  | 'settings'
  | 'data';

export type NavigationItem = {
  id: ViewId;
  label: string;
  description: string;
  icon: SpookyIconComponent | LucideIcon;
};

export const PRIMARY_NAVIGATION: readonly NavigationItem[] = [
  { id: 'home', label: 'Home', description: 'Your daily overview', icon: Home },
  { id: 'calendar', label: 'Calendar', description: 'Month and selected day', icon: CalendarDays },
  { id: 'tasks', label: 'Tasks', description: 'Plan and complete tasks', icon: ListChecks },
  { id: 'notes', label: 'Notes', description: 'Keep thoughts nearby', icon: NotebookPen },
  { id: 'more', label: 'More', description: 'All planner tools', icon: MoreHorizontal }
];

export const SIDEBAR_PRIMARY_NAVIGATION: readonly NavigationItem[] = [
  ...PRIMARY_NAVIGATION.filter(({ id }) => id !== 'more'),
  { id: 'favorites', label: 'Favorites', description: 'Saved items in one place', icon: Heart }
];

export const SECONDARY_NAVIGATION: readonly NavigationItem[] = [
  { id: 'events', label: 'Events', description: 'Dates, times and places', icon: GhostIcon },
  { id: 'shopping', label: 'Shopping', description: 'A cozy shopping list', icon: GhostIcon },
  { id: 'settings', label: 'Settings', description: 'Colors and preferences', icon: GhostIcon },
  { id: 'data', label: 'Data & backups', description: 'Protect local planner data', icon: GhostIcon }
];

export const ALL_NAVIGATION = [...PRIMARY_NAVIGATION, ...SECONDARY_NAVIGATION, ...SIDEBAR_PRIMARY_NAVIGATION.filter(({ id }) => id === 'favorites')] as const;

export const getNavigationItem = (viewId: ViewId) =>
  ALL_NAVIGATION.find((item) => item.id === viewId) ?? PRIMARY_NAVIGATION[0];

export const QUICK_ADD_OPTIONS = [
  { id: 'tasks' as const, label: 'New task', description: 'Add something you want to complete.', icon: ClipboardBatIcon },
  { id: 'calendar' as const, label: 'New event', description: 'Choose a date and plan an occasion.', icon: CalendarPumpkinIcon }
];
